webpackJsonp([5845135763691],{

/***/ 395:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"FreightDeploy","author":"Andrew Lynch"}},"markdownRemark":{"id":"/opt/build/repo/src/pages/my-second-post/index.md absPath of file >>> MarkdownRemark","html":"<p>Wow! I love blogging so much already.</p>\n<p>Did you know that “despite its name, salted duck eggs can also be made from\nchicken eggs, though the taste and texture will be somewhat different, and the\negg yolk will be less rich.”?\n(<a href=\"http://en.wikipedia.org/wiki/Salted_duck_egg\">Wikipedia Link</a>)</p>\n<p>Yeah, I didn’t either.</p>","frontmatter":{"title":"My Second Post!","date":"May 06, 2015"}}},"pathContext":{"slug":"/my-second-post/","previous":{"fields":{"slug":"/hello-world/"},"frontmatter":{"title":"Hello World"}},"next":{"fields":{"slug":"/hi-folks/"},"frontmatter":{"title":"New Beginnings"}}}}

/***/ })

});


// WEBPACK FOOTER //
// path---my-second-post-97316ab2091ae55c128e.js